import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import {getPriceWithCurrency, getQuotePriceWithTaxes, getTotalPrice} from "../../../../misc/helpers";
import GroheCartDeliveryColumn from "./groheCartDeliveryColumn";

const GroheCartColumns = (props) => {

  const {activeQuoteIndex, discountSections, fabricatorSettings, isPhoneNumberValidated, language, intl, isShort,
    showUnlockCalculations, showTotalItems} = props;

  const {isBackend, jobId, canSaveQuote} = document.kvConfig;
  const totalPrice = getTotalPrice();
  let grandTotal = getQuotePriceWithTaxes(totalPrice, discountSections);
  const pricingIsLocked = (fabricatorSettings.leadCaptureOnQuote || fabricatorSettings.leadCaptureShoppingCart)
    && !(isBackend && jobId && canSaveQuote) && !isPhoneNumberValidated;

  let allTaxes = totalPrice.priceTaxes.length
    ? totalPrice.priceTaxes
    : [{materialTax: totalPrice.materialTaxes}];
  let instTaxes = totalPrice.installationTaxes;
  // console.log("allTaxes", allTaxes);
  // console.log("totalPrice", totalPrice);
  // console.log("grandTotal", grandTotal);

  // const showTaxes = (pricingIsLocked || allTaxes.some(tax => tax.materialTax > 0)) && (!showUnlockCalculations || showTotalItems.includes("tax"));
  const showTaxes = !isShort;
  const showInstTaxes = instTaxes && (!showUnlockCalculations || showTotalItems.includes("tax"));
  const showTotal = !isShort && (!showUnlockCalculations || showTotalItems.includes("total"));

  let subTotalPrice = 0;
  // if (quotes.length > 1 && !showAllQuotesCartItemsList) {
    const quoteTotalPrice = getTotalPrice(activeQuoteIndex);
    // subTotalPrice = getQuotePriceWithTaxes(quoteTotalPrice, discountSections);
    subTotalPrice = quoteTotalPrice.materialPrice;
    allTaxes = quoteTotalPrice.priceTaxes.length
      ? quoteTotalPrice.priceTaxes
      : [{materialTax: quoteTotalPrice.materialTaxes}];
    instTaxes = quoteTotalPrice.installationTaxes;
  // }
  subTotalPrice = subTotalPrice.toFixed(2); // always round to 23.65, even if it is 23.00
  grandTotal = grandTotal.toFixed(2); // always round to 23.65, even if it is 23.00

  const getTaxColumn = (pricingIsLocked, taxObject, taxObjectIndex) => {
    // const showIncluded = !pricingIsLocked && (+taxObject.materialTax > 0);
    const taxTotal = taxObject.materialTax.toFixed(2); // always round to 23.65, even if it is 23.00
    // if (taxTotal <= 0) {
    //   return null
    // }
    const taxName = taxObject.nameIntl && taxObject.nameIntl[language]
      ? taxObject.nameIntl[language]
      : taxObject.state || intl.formatMessage({id: "grohe.cart.footer.tax"})
    return (
      <div className="gc-footer__item" key={taxObjectIndex}>
        <span className="gc-footer__item-title">{taxName}</span>
        <div className="gc-footer__item-value">
          {pricingIsLocked ? <LockedPrice/>  : getPriceWithCurrency(fabricatorSettings, taxTotal)}
        </div>
      </div>
    )
  }

  const LockedPrice = () => (
    <span className="price price--locked" onClick={() => {}}>
      <FormattedMessage id="grohe.cart.footer.pricingLocked"/>
    </span>
  )

  return (
    <Fragment>
      <div className="gc-footer__item">
        <span className="gc-footer__item-title">
          <FormattedMessage id="grohe.cart.confirm.columns.items"/>
        </span>
        <div className="gc-footer__item-value">
          {pricingIsLocked ? <LockedPrice/>  : getPriceWithCurrency(fabricatorSettings, subTotalPrice)}
        </div>
      </div>
      {showTaxes ? allTaxes.map((taxObject, taxObjectIndex) => {
        return getTaxColumn(pricingIsLocked, taxObject, taxObjectIndex)
      }) : null}
      {showInstTaxes ? (
        <div className="gc-footer__item">
          <span className="gc-footer__item-title">
            {intl.formatMessage({id: "grohe.cart.footer.instTax"}) +
              (!pricingIsLocked && (+instTaxes > 0)
                ? intl.formatMessage({id: "grohe.cart.footer.taxIncluded"})
                : "")}
          </span>
          <div className="gc-footer__item-value">
            {pricingIsLocked ? <LockedPrice/>  : getPriceWithCurrency(fabricatorSettings, instTaxes.toFixed(2))}
          </div>
        </div>
      ) : null}
      {/*{(quotes.length > 1) && !showAllQuotesCartItemsList && showTotal ? (*/}
      {/*  <div className="gc-footer__item">*/}
      {/*    <span className="gc-footer__item-title">*/}
      {/*      <FormattedMessage id="grohe.cart.footer.subtotal"/>*/}
      {/*    </span>*/}
      {/*    <div className="gc-footer__item-value">*/}
      {/*      {pricingIsLocked ? <LockedPrice/>  : getPriceWithCurrency(fabricatorSettings, subTotalPrice)}*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*) : null}*/}
      {isShort ? null : <GroheCartDeliveryColumn totalDeliveryCost={totalPrice.totalDeliveryCost}
                                                 pricingIsLocked={pricingIsLocked}/>}
      {showTotal ? (
        <div className="gc-footer__item">
          <span className="gc-footer__item-title">
            <FormattedMessage id="grohe.cart.footer.total"/>
          </span>
          <div className="gc-footer__item-value">
            {pricingIsLocked ? <LockedPrice/>  : getPriceWithCurrency(fabricatorSettings, grandTotal, null, true)}
          </div>
        </div>
      ) : null}
    </Fragment>
  )
};

GroheCartColumns.propTypes = {
  isShort: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {settings} = store.fabricatorState;
  const {discountSections} = store.priceWorksheetState;
  const {cartItems, showAllQuotesCartItemsList, sureTax} = store.cartState;
  const {isPhoneNumberValidated} = store.userState;
  const {language} = store.serverState;
  const {quotes, activeQuoteIndex} = store.quotesState;
  const {showUnlockCalculations, showTotalItems} = store.unlockCalculationsState;

  return {
    fabricatorSettings: settings,
    discountSections,
    cartItems,
    showAllQuotesCartItemsList,
    isPhoneNumberValidated,
    language,
    quotes,
    activeQuoteIndex,
    showUnlockCalculations,
    showTotalItems,
    sureTax,  // to update when response received
    // deliveryList,  // to update when delivery changed
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(GroheCartColumns))
)
